import { render, staticRenderFns } from "./Drugs.vue?vue&type=template&id=6fc56879&scoped=true"
import script from "./Drugs.vue?vue&type=script&lang=js"
export * from "./Drugs.vue?vue&type=script&lang=js"
import style0 from "./Drugs.vue?vue&type=style&index=0&id=6fc56879&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc56879",
  null
  
)

export default component.exports